import { scaleOP } from '@components/frame';
import { TILE_CONFIG } from '@v2/pages/common/constants/base.constants';

export const getGridConfig = (effectiveWidth: number, isSmallMode: boolean) => ({
  width: effectiveWidth,
  scale: scaleOP,
  initialBaseSize: isSmallMode ? TILE_CONFIG.BASE_WIDTH_SMALL : TILE_CONFIG.BASE_WIDTH,
  spaceBetween: isSmallMode ? TILE_CONFIG.SPACE_BETWEEN_SMALL : TILE_CONFIG.SPACE_BETWEEN_NORMAL,
});
